module.exports = __webpack_public_path__ + "img/code-wrapper-bg-higher@2x.c0c56888.png";